import { HttpClient } from '@angular/common/http';
import {HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from 'src/app/models/Role';
import { BL } from 'src/environments/environment';
import { ConfigService } from '../config/config.service';
import { CREW_INFO, ROLES, getItemFromSessionStorage } from 'src/app/utils/SessionStorageUtil';
import { ExternalCrewLoginData } from 'src/app/models/ExternalCrewLoginData';
import { ExternalTripAccessDataResponse } from 'src/app/models/ExternalTripAccessDataResponse';
import { ExternalCrewDataUpdate } from 'src/app/models/ExternalCrewDataUpdate';
import { CrewInfo } from 'src/app/models/CrewInfo';


@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  private readonly API_URL: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.API_URL = BL.protocol + this.configService.settings.base_href
  }

  getRoles(): Observable<Role> {
    return this.http.get<Role>(this.API_URL + BL.getRolesBasePath);
  }

  verifyRecaptchaToken(token: string) {
    return this.http.get<any>(`${this.API_URL}${BL.siteVerify}?token=${token}`);
  }

  externalCrewValidate(loginData: ExternalCrewLoginData, token: string): Observable<ExternalTripAccessDataResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',

      //security Dont Remove it
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
      'X-Frame-Options': 'sameorigin',
      'X-XSS-Protection': '1',
      'Authorization': token
    });
    return this.http.post<any>(`${this.API_URL}${BL.externalCrewValidate}`, loginData, { headers });
  }

  externalCrewUpdate(updateData: ExternalCrewDataUpdate, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'token': token
    });
    return this.http.post<any>(`${this.API_URL}${BL.externalCrewUpdate}`, updateData, { headers });
  }

  externalCrewResetPassword(anacCode: string, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'token': token
    });
    return this.http.post<any>(`${this.API_URL}${BL.externalCrewResetPassword}/${anacCode}`, {}, { headers });
  }

  sendEmailCode(anacCode: string, email: string): Observable<any> {
    return this.http.post<any>(`${this.API_URL}${BL.externalCrewSendEmailCode}`, { anacCode, email });
  }

  validateEmailCode(anacCode: string, code: string): Observable<any> {
    return this.http.post<any>(`${this.API_URL}${BL.externalCrewValidateEmailCode}`, { anacCode, code });
  }

  isAdmin(): boolean {
    const role = getItemFromSessionStorage<Role>(ROLES);
    return Array.isArray(role?.roles) && role.roles.includes('admin');
  }

  isExternal(): boolean {
    let crew = getItemFromSessionStorage<CrewInfo>(CREW_INFO);
    return crew?.type === 'external-crew';
  }

  getCrewCode(): string | undefined {
    let crew = getItemFromSessionStorage<CrewInfo>(CREW_INFO);
    return crew?.code.value;
  }
}
